import { IApiResponse } from "../../../@types/api-response.type";
import { Api } from "../ApiConfig"
import { ApiException } from "../ApiException"
import { IHoliday, IHolidayFilter } from "../../../@types/holiday.type";
import { IIdName } from "../../../@types/key-value.type";
import { IGrid } from "../../../@types/grid.type";
import { getErrorMessage } from "../../../utils/utils";


export const getHolidayById = async (id: string) => {
  try {
      const { data } = await Api.get(`/api/Holiday/GetHolidayById?id=${id}`)
      return data
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar o Feriado'))
  }
  
}

export const searchHolidays = async (holidayFilter: IHolidayFilter) : Promise<IGrid<IHoliday> | ApiException>=> {
  try {
      const response = await Api.post<IApiResponse<IGrid<IHoliday>>>(`/api/Holiday/SearchHolidays`, holidayFilter)
      return response.data.result
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar todos os Feriados'))
  }
}


export const addOrUpdateHoliday = async (holidayDto: IHoliday) => { 
  try {
      const { data } = await Api.post(`/api/Holiday/AddOrUpdateHoliday`, holidayDto)
      return data
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao criar o Feriado'))
  }
}

export const deleteHoliday = async (holidayId: string) => {
  try {
      const { data } = await Api.delete(`/api/Holiday/DeleteHoliday/${holidayId}`)
      return data
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao deletar o Feriado'))
  }
  
}

export const getAllHolidaysIdsAndNames = async (): Promise< IIdName[]> => {
  try {
    const { data } = await Api.get<IApiResponse<IIdName[]>>("/api/Holiday/GetHolidayTypes");
    return data.result;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao consultar ids e nomes dos Feriados'))
  }
}
  